import React, { useState, useEffect } from 'react';
import { Menu, X, Wrench } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // Note: handleScroll is defined inside the effect and setIsScrolled is stable by React design
  }, []);

  const scrollToSection = (sectionId, path) => {
    navigate(path);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
      }
    }, 100);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-md' 
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      {/* Main navigation */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            {/* Logo Icon */}
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center shadow-lg">
              <Wrench className="w-8 h-8 text-white" />
            </div>
            
            {/* Company Name */}
            <h1 className="text-2xl md:text-3xl font-bold text-blue-900">
              {companyInfo.name}
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('inicio', '/')}
              className="text-gray-700 hover:text-blue-700 font-medium transition-colors"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('servicios', '/servicios')}
              className="text-gray-700 hover:text-blue-700 font-medium transition-colors"
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('nosotros', '/nosotros')}
              className="text-gray-700 hover:text-blue-700 font-medium transition-colors"
            >
              Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('testimonios', '/testimonios')}
              className="text-gray-700 hover:text-blue-700 font-medium transition-colors"
            >
              Testimonios
            </button>
            <Button 
              onClick={() => scrollToSection('contacto', '/contacto')}
              className="bg-blue-700 hover:bg-blue-800 text-white"
            >
              Contáctanos
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('inicio', '/')}
                className="text-gray-700 hover:text-blue-700 font-medium transition-colors text-left"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('servicios', '/servicios')}
                className="text-gray-700 hover:text-blue-700 font-medium transition-colors text-left"
              >
                Servicios
              </button>
              <button 
                onClick={() => scrollToSection('nosotros', '/nosotros')}
                className="text-gray-700 hover:text-blue-700 font-medium transition-colors text-left"
              >
                Nosotros
              </button>
              <button 
                onClick={() => scrollToSection('testimonios', '/testimonios')}
                className="text-gray-700 hover:text-blue-700 font-medium transition-colors text-left"
              >
                Testimonios
              </button>
              <Button 
                onClick={() => scrollToSection('contacto', '/contacto')}
                className="bg-blue-700 hover:bg-blue-800 text-white w-full"
              >
                Contáctanos
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
